import * as React from 'react'
import style from './style.module.css'

interface PlaceholderGraphicProps {
  icon:IconType,
  desc?:string | JSX.Element,
  btn?:Btns,
  paddingTop?:number
}
interface Btns {
  text:string,
  onClick:Function
}
type IconType = 'write' | 'edit' | 'check' | 'risk' | 'noNet' | 'noComment' | 'income' | 'noContent' | string
export function PlaceholderGraphic({icon,desc,btn,paddingTop}:PlaceholderGraphicProps) {
  const iconImg = {
    write:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-x.png',
    edit:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-edit.png',
    check:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-check.png',
    risk:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-fx.png',
    noNet:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-wwl.png',
    noComment:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-wpl.png',
    noContent:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-wnr.png',
    income:'https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-sy.png'
  }

  return(
    <div className={style['placeholder-graphic']} style={{paddingTop:(paddingTop || paddingTop === 0)?paddingTop:'30%'}}>
      <div className={style['graphic-icon']}><img src={iconImg[icon] || icon} alt=""/></div>
      <div className={style['graphic-desc']}>{desc}</div>
      {
        btn && <div className={style['graphic-btn']}><span onClick={()=>btn.onClick()}>{btn.text}</span></div>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ../src/placeholder-graphic/index.tsx